/* Copyright 2013 The MathWorks, Inc. */

// This defines the Default gallery item widths in pixels based on two factors:
// 1. The gallery item row count
// 2. The gallery item text line count
define([], function () {
    return {
        // item row count is 1:
        1: {
            // item text line count is 0 (no text)
            0: 68,

            // item text line count is 1
            1: 68,

            // item text line count is 2
            2: 68
        },

        // item row count is 2:
        2: {
            // item text line count is 0 (no text)
            0: 52,

            // item text line count is 1
            1: 102

            // item text line count 2 is not supported for this case
        },

        // item row count is 3:
        3: {
            // item text line count is 0 (no text)
            0: 52,

            // item text line count is 1
            1: 98

            // item text line count 2 is not supported for this case
        }
    };
});